import { memo } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { BzModal, BzModalBody } from '../../components'

const SuccessModal = () => {

    const modals = useSelector(state => state?.modals?.modals);

    return (
        <Container>
            <BzModal size='sm' show={modals['USER_DELETE_SUCCESS_MODAL']} >
                <BzModalBody>
                    <Row className='g-0 py-3'>
                        <Col className='text-center'>
                            <div className='icon-64 icon-done icon-positive'></div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-3 pb-4'>
                        <Col className='text-center'>
                            <div className='font-medium font-size4 color-text'>User deleted successfully!</div>
                        </Col>
                    </Row>
                </BzModalBody>
            </BzModal>
        </Container>
    )
}

export default memo(SuccessModal)
